import { FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';

interface CalloutTitleHighlightProps extends TypographyProps {}

const CalloutTitleHighlight: FC<CalloutTitleHighlightProps> = ({ children, ...props }) => {
    return (
        <Typography component="span" color="primary" variant="h6" fontWeight="bold" {...props}>
            {children}
        </Typography>
    );
};

export type { CalloutTitleHighlightProps };
export default CalloutTitleHighlight;
